var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTask = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_task",
    transform: "translate(-18 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 22,
    height: 22,
    transform: "translate(18 87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "task_FILL0_wght300_GRAD-25_opsz20",
    d: "M224.23-824.792l-1.42-1.436a.5.5,0,0,0-.2-.128.674.674,0,0,0-.219-.037.708.708,0,0,0-.223.037.516.516,0,0,0-.2.125.579.579,0,0,0-.179.43.571.571,0,0,0,.175.426l1.772,1.752a.834.834,0,0,0,.218.152.589.589,0,0,0,.256.055.6.6,0,0,0,.259-.055.753.753,0,0,0,.215-.152l3.664-3.664a.579.579,0,0,0,.172-.4.539.539,0,0,0-.175-.408.566.566,0,0,0-.406-.175.553.553,0,0,0-.4.175Zm-3.612,4.87a1.294,1.294,0,0,1-.955-.395,1.31,1.31,0,0,1-.391-.958v-13.294a1.3,1.3,0,0,1,.395-.958,1.307,1.307,0,0,1,.96-.395h6.319a1.415,1.415,0,0,1,.512.095,1.365,1.365,0,0,1,.463.307l2.658,2.652a1.369,1.369,0,0,1,.315.465,1.394,1.394,0,0,1,.1.517v10.61a1.306,1.306,0,0,1-.4.96,1.306,1.306,0,0,1-.959.395Zm6.1-12.4v-2.52h-6.089a.264.264,0,0,0-.19.086.264.264,0,0,0-.086.19v13.291a.264.264,0,0,0,.086.19.264.264,0,0,0,.19.086h9.011a.264.264,0,0,0,.19-.086.264.264,0,0,0,.086-.19v-10.368h-2.52a.656.656,0,0,1-.482-.2.656.656,0,0,1-.2-.482Zm-6.365-2.52v0Z",
    transform: "translate(-196.131 925.922)",
    fill: "#8d8d8d"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTask, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/task.be89ae8a.svg";
export { ForwardRef as ReactComponent };